import { useEffect, useState } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import HoldingPage from './HoldingPage';
import TermsOfService from '../Legal/TermsOfService';
import PrivacyPolicy from '../Legal/PrivacyPolicy';
import CookieNotice from '../Legal/CookieNotice';
import ContactUs from '../Legal/ContactUs';
import StarfieldBackground from '../StarfieldBackground';

const LEGAL_PREFIXES = ['#/privacy', '#/terms', '#/cookies', '#/contact'];

const isLegalHash = (hash) => LEGAL_PREFIXES.some(p => (hash || '').startsWith(p));

// What a visitor without preview access sees: the holding page, or a legal
// page when the link points at one. Used by PreviewGate inside the full app
// and, on its own, by the holding-only build (src/holding.jsx), which the
// server sends to visitors without the preview cookie (functions/_middleware.js).
export default function HoldingShell() {
  const [hash, setHash] = useState(window.location.hash || '');

  useEffect(() => {
    const onHash = () => setHash(window.location.hash || '');
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);

  if (isLegalHash(hash)) {
    return (
      <HashRouter>
        <StarfieldBackground />
        <Routes>
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<CookieNotice />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
      </HashRouter>
    );
  }
  return <HoldingPage />;
}
